import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { ISupplementCategory } from '@interfaces/lookups';
import { handleGetSupplementCategories } from '@store/features/supplementCategories/actions';
import {
  supplementCategoriesErrorSelector,
  supplementCategoriesIsLoadingSelector,
  supplementCategoriesIsReadySelector,
  supplementCategoriesSelector,
} from '@store/features/supplementCategories/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useSupplementCategories = (): ISupplementCategory[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(supplementCategoriesSelector);
  const isLoading = useSelector(supplementCategoriesIsLoadingSelector);
  const isReady = useSelector(supplementCategoriesIsReadySelector);
  const error = useSelector(supplementCategoriesErrorSelector);

  const handleFetch = useCallback(() => {
    dispatch(handleGetSupplementCategories());
  }, [dispatch]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.supplementCategoriesError'),
    handleFetch,
  });

  return data;
};

export default singletonHook([], useSupplementCategories);
